<template lang="pug">
	b-tabs
		b-tab
			template(slot="title")
				i.icon-puzzle
			div.p-3
				h6 Creative Settings
				div
					small.text-muted Here are the main settings of the project.
				span(v-if="Template.SelectedTemplate.id !== 9")
					div.clearfix.mt-4
						span Websites data
					div
						small.text-muted.pre Here you can change websites code
					div.btn-group.btn-group-justified(:style="{width: '100%', 'padding-top': '5px'}")
						button.btn.btn-outline-secondary(@click="downloadWebsitesCode()" :style="{width: '50%'}") Download
						button.btn.btn-outline-secondary.float-right(v-if="Template.SelectedTemplate.id === 5" @click="uploadWebsitesCode()" :style="{width: '50%'}") Upload
				span(v-if="Template.SelectedTemplate.id !== 9")
					div.clearfix.mt-4
						span Extra css styles
					div
						small.text-muted.pre Here you can override css styles
						div.btn-group.btn-group-justified(:style="{width: '100%', 'padding-top': '5px'}")
								button.btn.btn-outline-secondary(@click="downloadExtraStyles()" :style="{width: '50%'}") Download
								button.btn.btn-outline-secondary.float-right(@click="uploadExtraStyles()" :style="{width: '50%'}") Upload
				span(v-if="Template.SelectedTemplate.id === 10 || Template.SelectedTemplate.id === 6 || Template.SelectedTemplate.id === 9")
					div.clearfix.mt-4
						span Steam JSON
					div
						small.text-muted.pre Here you can change Steam JSON
					div.btn-group.btn-group-justified(:style="{width: '100%', 'padding-top': '5px'}")
						button.btn.btn-outline-secondary(@click="downloadSteamJSON()" :style="{width: '50%'}") Download
						button.btn.btn-outline-secondary.float-right(@click="uploadSteamJSON()" :style="{width: '50%'}") Upload
				span
					div.clearfix.mt-4
						span Inject js
					div
						small.text-muted.pre Here you can upload .js file to be injected when creative is loaded
					div.btn-group.btn-group-justified(:style="{width: '100%', 'padding-top': '5px'}")
						button.btn.btn-outline-secondary(@click="downloadInjectJs()" :style="{width: '50%'}") Download
						button.btn.btn-outline-secondary.float-right(@click="uploadInjectJs()" :style="{width: '50%'}") Upload
				div.sidebar-settings(v-for="setting in settings" v-if="setting['section'] === 'main'")
					SettingControls(:setting="setting")

				SettingsContentSections
		b-tab
			template(slot="title")
				i.fa.fa-bar-chart
			div.p-3
				h6 Tracking
				div
					small.text-muted Here you can setup additional tracking of the users actions in the creative.
				div.aside-settings(v-for="setting in settings" v-if="setting['section'] === 'tracking'")
					SettingControls(:setting="setting" :section="'tracking'")
		b-tab(v-on:click="tabClick('assets')")
			template(slot="title")
				i.icon-folder
			div.p-3
				h6 Assets Settings
				div
					small.text-muted Here are the assets, that used in this project.
				div.aside-settings(v-for="setting in settings" v-if="setting['section'] === 'assets'")
					SettingControls(:setting="setting" :section="'tracking'")
				SettingsContentAssets
		b-tab(v-on:click="tabClick('tag-merger')")
			template(slot="title")
				i.fa.fa-code
			div.p-3
				h6 Tag Merger
				div
					small.text-muted Here you can edit merged tag for different devices
				div.aside-settings(v-for="setting in settings" v-if="setting['section'] === 'tag-merger'")
					SettingControls(:setting="setting" :section="'tag-merger'")
		b-tab(v-on:click="tabClick('global-settings')")
			template(slot="title")
				i.fa.fa-check-square-o
			div.p-3
				h6 Global Settings
				div
					small.text-muted Here are the global settings, which are common for all projects.
				span
					div.clearfix.mt-4
						span Airbrake filtered IPs
					div
						small.text-muted.pre Airbrake will not send reports from this IPs
					div.btn-group.btn-group-justified(:style="{width: '100%', 'padding-top': '5px'}")
						button.btn.btn-outline-secondary(@click="editAirbrakerIPs()" :style="{width: '50%'}") Edit
						//button.btn.btn-outline-secondary.float-right(@click="uploadWebsitesCode()" :style="{width: '50%'}") Upload
				span
					div.clearfix.mt-4
						span Conflict detection tool
					//div
						small.text-muted.pre AirBraker will not send reports from this IPs
					div.btn-group.btn-group-justified(:style="{width: '100%', 'padding-top': '5px'}")
						button.btn.btn-outline-secondary(@click="getConflictDetectionToolTag()" :style="{width: '50%'}") View tag
						button.btn.btn-outline-secondary(v-if="showUpload" @click="uploadConflictDetectionToolTag()" :style="{width: '50%'}") Upload
				div.aside-settings(v-for="setting in globalSettings")
					SettingControls(:setting="setting" :section="'global'")
		b-tab(v-on:click="tabClick('domains')")
			template(slot="title")
				i.fa.fa-link
			div
				.p-3
					h6 Domains
					div
						small.text-muted Here you can view css and json for domains
				DomainsList
</template>

<script>

	import Screen 						from "./../../mixins/screen"

	import SettingControls 				from "./SettingControls.vue"
	import SettingsContentSections		from "./SettingsContentSections"
	import SettingsContentTracking		from "./SettingsContentTracking"
	import SettingsTagMerger			from "./SettingsTagMerger";
	import SettingsContentAssets 		from "./SettingsContentAssets"
	import SettingsEditAirbrakerFilteredIps from "./SettingsEditAirbrakerFilteredIps"
	import SettingsConflictDetectionToolViewTag from "./SettingsConflictDetectionToolViewTag";
	import SectionsChangesHistory 		from "./SectionsChangesHistory";
	import DomainsList 					from "@/components/Dashboard/DomainsList";

	import { Settings } 				from "./../../services/Settings"
	import { Template }					from "./../../services/Template"
	import { User } from "../../services/User";
	import SetupSettings from "@/settings/settings.json";

	export default {
		name: "SettingsContent",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Project Changed", "Settings Changed"]
		},
		components: {
			SettingControls,
			SettingsContentSections,
			SettingsContentTracking,
			SettingsTagMerger,
			SettingsContentAssets,
			SettingsEditAirbrakerFilteredIps,
			SettingsConflictDetectionToolViewTag,
			SectionsChangesHistory,
			DomainsList
		},
		data() {


			this.globalSettings = {};
			this.settings = {};
			this.Template = Template;

			return {
				showUpload: false,
				showed: true
			};

		},
		created() {
			this.collectData();
		},
		methods: {
			collectData() {


				this.showUpload = User.User.IsAdmin;
				this.settings = _.orderBy(_.filter(Settings.getSelectedProjectSettings(), o => o.id), o => {return o["priority"] || 9999});

			},
			tabClick(tab_name) {

				Broadcast.call("Settings Tab Changed", [tab_name]);

			},
			downloadWebsitesCode() {

				Template.downloadWebsitesCode();

			},

			downloadInjectJs() {

				let fileName = 'inject.js';
				let fileFolder = 'inject-js';

				switch (Template.SelectedTemplate.id) {
					case 5:
						fileName = 'inject-mobile.js';
						break
					case 9:
						fileName = 'inject-mpu.js';
						break
					case 11:
						fileName = 'inject-floor.js';
						break;
					default:
						fileName = 'inject.js';
						break;
				}

				let url = `${location.protocol}//${SetupSettings["domain"]}:${location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"]}/${fileFolder}/${fileName}`;

				let xhr = new XMLHttpRequest();
				xhr.open("GET", url, true);
				xhr.responseType = "blob";
				xhr.withCredentials = true;
				xhr.onload = function(){
					let urlCreator = window.URL || window.webkitURL;
					let websitesUrl = urlCreator.createObjectURL(this.response);
					let tag = document.createElement('a');
					tag.href = websitesUrl;
					tag.download = fileName;
					document.body.appendChild(tag);
					tag.click();
					document.body.removeChild(tag);
				};
				xhr.send();

			},

			uploadInjectJs() {

				let input = document.createElement('input');
				input.type = 'file';
				input.style.position = 'absolute';
				input.style.left = '0';
				input.style.top = '0';
				input.style.transform = 'scale(0.1)';
				input.style.visibility = 'hidden';
				input.accept = '.js';
				document.body.appendChild(input);

				input.addEventListener('change', e => {

					let file = e.target.files[0];

					let formData = new FormData();

					formData.append("file", file);
					formData.append("templateId", Template.SelectedTemplate.id);

					let url = 'http://' + SetupSettings["domain"] + ':' + SetupSettings["port"] + '/injectjs/get';
					if (location.protocol === 'https:') url = 'https://' + SetupSettings["domain"] + ':' + SetupSettings["portSSL"] + '/injectjs/get';

					let xhr = new XMLHttpRequest();

					xhr.withCredentials = true;

					xhr.open("POST", url);

					xhr.send(formData);

					document.body.removeChild(input);

				});

				input.click();

			},

			editAirbrakerIPs() {

				Broadcast.call("Show Settings Edit Airbraker Filtered Ips");

				Server.sendToSocket({
					GetAirbrakerFilter: {}
				});
			},

			uploadConflictDetectionToolTag() {
				Server.sendToSocket({
					UploadConflictDetectionToolTag: {}
				});
			},

			getConflictDetectionToolTag() {
				Broadcast.call("Show Settings Conflict Detection Tool View Tag");
			},

			uploadWebsitesCode() {
				let input = document.createElement('input');
				input.type = 'file';
				input.style.position = 'absolute';
				input.style.left = '0';
				input.style.top = '0';
				input.style.transform = 'scale(0.1)';
				input.style.visibility = 'hidden';
				input.accept = 'application/JSON, text/plain';
				document.body.appendChild(input);

				//if (asset.type === 'image') input.accept = "image/png, image/jpeg";

				input.addEventListener('change', e => {

					let file = e.target.files[0];

					Template.uploadWebsitesCode(file);
					//Asset.replaceAsset(asset, file);

					document.body.removeChild(input);

				});

				input.click();
			},
			downloadExtraStyles() {

				const folder = Template.SelectedTemplate.id === 5 ? 'websites-mobile' : 'websites';
				const fileName = 'extra-styles.css';

				let url = `${location.protocol}//${SetupSettings["domain"]}:${location.protocol === 'https:' ? SetupSettings["portSSL"] : SetupSettings["port"]}/${folder}/${fileName}`;

				let xhr = new XMLHttpRequest();
				xhr.open("GET", url, true);
				xhr.responseType = "blob";
				xhr.withCredentials = true;
				xhr.onload = function(){
					let urlCreator = window.URL || window.webkitURL;
					let stylesUrl = urlCreator.createObjectURL(this.response);
					let tag = document.createElement('a');
					tag.href = stylesUrl;

					tag.download = Template.SelectedTemplate.id === 5 ? 'extra-styles-mobile.css' : fileName;
					document.body.appendChild(tag);
					tag.click();
					document.body.removeChild(tag);
				};
				xhr.send();

			},
			downloadSteamJSON() {

				Template.downloadSteamJSON();

			},
			uploadSteamJSON() {
				let input = document.createElement('input');
				input.type = 'file';
				input.style.position = 'absolute';
				input.style.left = '0';
				input.style.top = '0';
				input.style.transform = 'scale(0.1)';
				input.style.visibility = 'hidden';
				input.accept = 'application/JSON, text/plain';
				document.body.appendChild(input);

				input.addEventListener('change', e => {

					let file = e.target.files[0];

					Template.uploadSteamJSON(file);

					document.body.removeChild(input);

				});

				input.click();
			},
			uploadExtraStyles() {
				let input = document.createElement('input');
				input.type = 'file';
				input.style.position = 'absolute';
				input.style.left = '0';
				input.style.top = '0';
				input.style.transform = 'scale(0.1)';
				input.style.visibility = 'hidden';
				input.accept = '.css, .js, text/css, application/x-javascript';
				document.body.appendChild(input);


				input.addEventListener('change', e => {

					let file = e.target.files[0];

					Template.uploadExtraStyles(file);

					document.body.removeChild(input);

				});

				input.click();
			},

			showSeparateCss() {
				Broadcast.call("Show Separate Css", [Template.SelectedTemplate.id]);
			}
		}
	}
</script>

<style lang="sass">

	aside.aside-menu
		background-color: #3a4149
		border-left: 1px solid #23282c
		color: #f3f4f5
		width: 390px
		&::-webkit-scrollbar
			width: 5px
		&::-webkit-scrollbar-track
			background: #23282c
		&::-webkit-scrollbar-thumb
			background: #111213

		.switch-slider
			background-color: #343b41
			border: 1px solid #23282c

		.nav-tabs
			font-size: 0.875rem

			.nav-link
				color: #f3f4f5

			.nav-item.show .nav-link, .nav-link.active
				color: #f3f4f5
				background-color: #343b41
				border-color: #23282c #23282c #23282c

			.nav-link.active
				color: #20a8d8
				border-right-color: #23282c
				border-left-color: #23282c

			.nav-link:hover
				border-right-color: #23282c
				border-left-color: #23282c

		.tab-content
			border: 0
			border-top: 1px solid #23282c
			border-radius: 0 0 .25rem .25rem
			background: #3a4149

			.banner-tabs
				display: flex
				white-space: nowrap
				border-bottom: 1px solid #23282c
				flex-direction: row
				align-items: stretch
				width: 100%
				margin-top: 20px
				color: #73818f
				user-select: none

				.banner-tab
					border: 1px solid transparent
					border-top-left-radius: .25rem
					border-top-right-radius: .25rem
					margin-bottom: -1px
					cursor: pointer
					text-align: center
					flex: 1

				.banner-tab.active
					color: #f3f4f5
					background-color: #343b41
					border-color: #23282c #23282c #23282c

				.banner-tab:hover, .banner-tab:focus
					border-color: #23282c #23282c #23282c

			.banner-tabs-content
				margin-top: -1px
				background-color: #343b41
				border: 1px solid #23282c
				border-radius: 0 0 .25rem .25rem
				font-size: 0

				.banner-tab-content
					display: none
					padding: 16px

					.aside-settings:nth-child(2)
						margin-top: 0

				.banner-tab-content.active
					display: block

		select
			background-color: #515b65
			border-color: #515b65
			color: #fff
			margin-top: 4px
			width: auto

	html:not([dir="rtl"]) .aside-menu
		right: 0
		margin-right: -390px

</style>
